/**
 * This object is a singleton instance of a clockWork.
 */
var clockWork = (function () {
	var t = {};
	t.currentTime = moment();

	//Update the time each second
	setInterval(function(){
		t.currentTime = moment();
	},1000);

	/**
	 * Get current date formatted with moment('ll')
	 *
	 * @returns string
	 */
	t.getDate = function(){
		return t.getCurrentTimeFormatted("ll");
	};

	/**
	 * Get current weekday formatted with moment('dddd')
	 *
	 * @returns string
	 */
	t.getWeekday = function(){
		return t.getCurrentTimeFormatted("dddd");
	};

	/**
	 * Get current time formatted with moment('HH:mm')
	 *
	 * @returns string
	 */
	t.getTime = function(){
		return t.getCurrentTimeFormatted("HH:mm:ss");
	};

	/**
	 * Get current time formatted with custom format
	 *
	 * @param format
	 * @returns string
	 */
	t.getCurrentTimeFormatted = function(format) {
		return t.getTimeFormatted(format);
	};

	/**
	 * Get time formatted.
	 *
	 * @param format
	 * @param timestamp
	 * @returns {string}
	 */
	t.getTimeFormatted = function (format, timestamp) {
		if (timestamp === undefined) {
			timestamp = t.currentTime.unix();
		}
		return moment(timestamp * 1000)
			.locale(textHandler.getLanguageTag())
			.format(format);
	};

	return t;
})();
